import CampaignDashboard from '../../pages/adminTools/campaignDashboard';
import EmailConfiguration from '../../pages/adminTools/emailConfiguration';
import CampaignAdListing from '../../pages/adminTools/campaignAdListing';
import XmlImportLogs from '../../pages/adminTools/xmlImportLogs';

const adminToolRoutes = [
  {path: 'campaign', name: 'CampaignDashboard', component: CampaignDashboard},
  {
    path: 'email-configuration',
    name: 'EmailConfiguration',
    component: EmailConfiguration,
  },
  {
    path: 'campaign-ad-listing',
    name: 'CampaignAdListing',
    component: CampaignAdListing,
  },
  {
    path: 'xml-import-logs',
    name: 'XmlImportLogs',
    component: XmlImportLogs,
  },
];

export default adminToolRoutes;
